module.exports = __webpack_public_path__ + "img/logo-imprimax.53636072.svg";